import { BOOKING_GA_CATEGORIES, BookingPathKeys } from '../../paths';

export const APPOINTMENT_DETAILS_STRINGS = {
    BookAppointment: 'Book appointment',
    PageTitle: 'Zocdoc | Booking | Review',
    WereBookingYourAppointment: "We're booking your appointment",
    ThisCouldTakeAMinuteOrTwo: 'This should just take a few seconds',
};

export const ANIMATION_DELAY = 3200;
export const POLLING_DELAY = 3000;

export const APPOINTMENT_DETAILS_GA_CATEGORY =
    BOOKING_GA_CATEGORIES[BookingPathKeys.appointmentDetailsPath];

export const GaActionText = {
    clickEditPhoneNumber: 'Click On Phone',
    selectInsuranceId: 'Select Insurance Member Id',
    selectDoctorNotes: 'Select Doctor Notes',
    clickBookAppointment: 'Click Book Appointment',
    bookingApptClicked: 'BookingApptClicked',
    trackExposedControlsExisting: 'View Exposed Controls - Existing',
    trackExposedControlsNew: 'View Exposed Controls - New',
    trackShowRequiredMemberIdField: 'Show Required Member Id Field',
};
